import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';

export const FileTileContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.md}px;
  color: ${({ theme }) => theme.colors.grey_1};
  background: ${({ theme }) => theme.colors.beige_2};
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};

  ${media.tablet`
    flex-direction: column;
    align-items: flex-start;
  `}

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.appearance.box_shadow_hover};
    color: ${({ theme }) => theme.colors.grey_1};
    background: ${({ theme }) => theme.colors.purple_5};
  }
`;

export const SimpleFilesListCtas = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;

export const SimpleFilesListRow = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  width: fit-content;
  height: fit-content;
  line-height: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;

export const SimpleFilesListBody = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  width: fit-content;
  height: fit-content;
  line-height: 1;
  margin-top: 2px;
`;

export const SimpleFilesListSection = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
